<template>
    <q-card>
        <q-toolbar>
            <q-toolbar-title class="text-center">
                {{ heading }} ({{ total }})
            </q-toolbar-title>
        </q-toolbar>
        <q-card-section class="bg-grey-1">
            <remaining-height
              class="custom-scrollbar custom-scrollbar--lg"
              :disable="$q.screen.lt.lg">
              <posts
                :filters="filters"
                persist
                infinite-scroll
                scroll-target=".custom-scrollbar"
                @total="total = $event"
              >
                <template v-slot="{ visiblePosts }">
                  <post
                    v-for="post in visiblePosts"
                    :key="post.id"
                    :post="post"
                    notes
                    trash
                    actions
                    popup
                    class="q-my-md"
                  />
                </template>
              </posts>
            </remaining-height>
        </q-card-section>
    </q-card>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { PostFilters, OpenDateRange } from '@/type';
import { getPreLossRange, getPostLossRange } from '@/client/client';
import Posts from '@/social/post/list/Posts.vue';
import { status } from '@/social/post/post';
import Post from '@/social/post/card/Post.vue';
import RemainingHeight from '../../layout/RemainingHeight.vue';

interface Data {
  total: number,
}

export default defineComponent({
  components: {
    Posts,
    Post,
    RemainingHeight,
  },
  props: {
    clientId: {
      type: Number,
      required: true,
    },
    dateOfLoss: {
      type: String,
      required: true,
    },
    postDateOfLoss: {
      type: Boolean,
      default: false,
    },
  },
  data(): Data {
    return {
      total: 0,
    };
  },
  computed: {
    heading(): string {
      return this.postDateOfLoss ? 'Post Loss' : 'Pre Loss';
    },
    dateRange(): OpenDateRange {
      if (this.postDateOfLoss) {
        return getPostLossRange(this.dateOfLoss);
      }
      return getPreLossRange(this.dateOfLoss);
    },
    filters(): PostFilters {
      return {
        clientIds: [this.clientId],
        statuses: [
          status.SAVED,
          status.ESCALATED,
          status.RESOLVED,
        ],
        isOnTimeline: true,
        isTrashed: false,
        since: this.dateRange.start,
        until: this.dateRange.end,
      };
    },
  },
});
</script>
